import React from "react"
import PropTypes from "prop-types"
import { Button, Card, CardBody, CardHeader } from "reactstrap"

// Session and profile states that must resolve before any protected page renders.
// These used to live inside home.js, which meant they only ever protected /home —
// deep-linking anywhere else during a slow fetch rendered a half-populated page.
const MESSAGES = {
  resolving: {
    title: "Loading your SAGE account",
    body: "Finishing sign-in...",
  },
  loading: {
    title: "Loading your SAGE account",
    body: "Just a moment while we load your profile.",
  },
  // Same screen as `loading`, with a Retry revealed. Changing the heading as
  // well made a healthy-but-slow fetch look like a failure.
  slow: {
    title: "Loading your SAGE account",
    body: "Just a moment while we load your profile.",
    retry: "Retry",
  },
  missing: {
    title: "We're setting up your SAGE account",
    body:
      "Your login worked, but your SAGE profile is not ready yet. Click Retry.",
    retry: "Retry",
  },
  error: {
    title: "Could not load your account",
    body: "Please try again.",
    retry: "Retry",
  },
}

const SessionGate = ({ state, detail, onRetry }) => {
  const message = MESSAGES[state] || MESSAGES.loading

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 24,
        backgroundColor: "#f8f8fb",
      }}
    >
      <Card className="border border-dark" style={{ maxWidth: 520, width: "100%" }}>
        <CardHeader>{message.title}</CardHeader>
        <CardBody>
          <p>{message.body}</p>
          {message.retry && onRetry && (
            <Button color="primary" onClick={onRetry}>
              {message.retry}
            </Button>
          )}
          {detail && (
            <p style={{ marginTop: 8, fontSize: 12, opacity: 0.7 }}>{detail}</p>
          )}
        </CardBody>
      </Card>
    </div>
  )
}

SessionGate.propTypes = {
  state: PropTypes.oneOf(["resolving", "loading", "slow", "missing", "error"])
    .isRequired,
  detail: PropTypes.string,
  onRetry: PropTypes.func,
}

export default SessionGate
